<template lang="html">
  <div class="merchant-container">
    <div class="breadCrumb-container">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>{{ $t('message.download') }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t('message.downloadTasks') }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
 <div class="flex-row second-tip">
   <div class="title"></div>
           <!--    <div class="title"></div>
            <div class="flex-row search-container">
            <el-input class="appManagement-search"
                :placeholder="$t('message.enterKeyword')"
                v-model="accountInfo"  @keyup.enter.native="searchAccount" clearable>
            </el-input>
            <el-button  class="search-btn" icon="el-icon-search" @click="searchAccount"></el-button>
        </div>-->

    <div class="flex-row search-container">
      <div class="select-input-container" style="right:40px" >
          <el-input class="reachInput"
                    :placeholder="$t('message.enterKeyword')"
                    v-model="downloadsearch"  @keyup.enter.native="searchAccount"
                    clearable>
          </el-input>
            <el-select class="rearchSelect" v-model="paramType" :placeholder="$t('message.pleaseChoose')"  >
              <el-option v-for="item in queryOptions" :key="item.value" :label="item.label" :value="item.value" @click.native="getDivision()">
              </el-option>
            </el-select>
      </div>
      <el-button  class="search-btn" icon="el-icon-search" @click="searchAccount"></el-button>
    </div>
    </div>
    <div class="body-container">
      <div class="table-container verifone-panel">
        <div class="table-main btn-table downloadList-table">
          <template>
            <el-table :header-cell-style="tableHeaderColor" :data="tableData" tooltip-effect="dark" style="width: 100%">
              <el-table-column prop="taskName" :label="$t('message.downloadTask')" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <!-- <el-button @click="handleClick(scope.row)" type="text" size="small">{{ scope.row.taskName }}</el-button> -->
                  <a class="taskName" @click="handleDetail(scope.row)">{{ scope.row.taskName }}</a>
                  <!-- </template> -->
                </template>
              </el-table-column>
              <el-table-column prop="taskType" :label="$t('message.type')" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span v-if="scope.row.taskType == 0" size="small">{{ $t('message.appDownload') }}</span>
                  <span v-if="scope.row.taskType == 1" size="small">{{ $t('message.appParam') }}</span>
                  <span v-if="scope.row.taskType == 2" size="small">{{ $t('message.terminalParam') }}</span>
                  <span v-if="scope.row.taskType == 3" size="small">{{ $t('message.appDelete') }}</span>
                  <span v-if="scope.row.taskType == 4" size="small">{{ $t('message.appResourceFile') }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="ctime" :label="$t('message.createDate')" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column prop="total" :label="$t('message.total')" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column prop="undo" :label="$t('message.notStart')" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column prop="success" :label="$t('message.downSuccess')" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column prop="fail" :label="$t('message.downFail')" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column prop="done" :label="$t('message.installSuccess')" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column prop="unfinished" :label="$t('message.installFail')" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column prop="status" :label="$t('message.status')" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span v-if="scope.row.status == 0" size="small" style="color: #00A0E8;">{{ $t('message.notStart') }}</span>
                  <span v-if="scope.row.status == 1" size="small" style="color: #53BFB7;">{{ $t('message.inprogress') }}</span>
                  <span v-if="scope.row.status == 2" size="small" style="color: #E51C23;">{{ $t('message.cancelled') }}</span>
                  <span v-if="scope.row.status == 3" size="small" style="color: #8E8E8E;">{{ $t('message.done') }}</span>
                </template>
              </el-table-column>
              <el-table-column fixed="right" :label="$t('message.operation')" width="120">
                <template slot-scope="scope">
                  <div v-if="queryFlag">
                    <el-button
                      v-if="scope.row.status == 0 || scope.row.status == 1"
                      class="end-btn verifone-btn"
                      type="danger"
                      plain
                      icon="el-icon-close"
                      @click="handleStopTask(scope.row)"
                      size="small"
                    >
                      {{ $t('message.cancel') }}
                    </el-button>
                    <template v-if="scope.row.status == 3 || scope.row.status == 2">
                      <el-button class="end-btn invisible-btn verifone-btn" type="primary" plain size="small"></el-button>
                    </template>
                  </div>
                  <div v-else>
                    <el-button
                      v-if="scope.row.status == 0 || scope.row.status == 1"
                      disabled
                      class="end-btn verifone-btn"
                      type="danger"
                      plain
                      icon="el-icon-close"
                      @click="handleStopTask(scope.row)"
                      size="small"
                    >
                      {{ $t('message.cancel') }}
                    </el-button>
                    <template v-if="scope.row.status == 3 || scope.row.status == 2">
                      <el-button class="end-btn verifone-btn invisible-btn" type="primary" plain size="small"></el-button>
                    </template>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </div>

        <div class="pagination-main">
            <el-pagination background layout="prev, pager, next"
            :current-page="pageNum"
            :page-count="pageCount"
            @current-change="changePage">
            </el-pagination>
         </div>
      </div>
    </div>

    <el-dialog title="" :visible.sync="downloadDialogVisible" width="30%" class="quit-dialog  btn-table">
      <div class="detail-row">
        <h4>{{ $t('message.totalTerminals') }}:&nbsp;&nbsp;</h4>
        <span>{{ downloadTotal }}</span>
      </div>
      <div class="detail-row">
        <h4 class="downloadLabel">{{ $t('message.downloadTime') }}:&nbsp;&nbsp;</h4>
        <div class="" v-if="downloadType == 0">
          <span>{{ $t('message.nextContact') }}</span>
        </div>
        <div class="" v-if="downloadType == 1">
          <span class="downloadDate">{{ downloadDate }}</span>
          <span>{{ downloadTime }}</span>
        </div>
      </div>
      <div class="detail-row">
        <h4 class="downloadLabel">{{ $t('message.installTime') }}:&nbsp;&nbsp;</h4>
        <div class="" v-if="installType == 0">
          <span>{{ $t('message.nextContact') }}</span>
        </div>
        <div class="" v-if="installType == 1">
          <span class="downloadDate">{{ installDate }}</span>
          <span>{{ installTime }}</span>
        </div>
      </div>
      <div class="detail-row">
        <h4>{{ $t('message.installNotify') }}:&nbsp;&nbsp;</h4>
        <div class="" v-if="remindType == 0">
          <span>{{ $t('message.silentInstall') }}</span>
        </div>
        <div class="" v-if="remindType == 1">
          <span>{{ $t('message.askCashier') }}</span>
        </div>
      </div>
      <div class="detail-row">
        <h4>{{ $t('message.pushRange') }}:&nbsp;&nbsp;</h4>
        <div class="">
          <span>{{ releaseRange }}</span>
        </div>
      </div>
      <h4>{{ $t('message.appLists') }} ({{ appListDownload.length }})</h4>
      <el-table :data="appListDownload" width="190" :max-height="518" :show-header="false">
        <el-table-column width="50" property="date" label="日期">
          <template slot-scope="scope">
            <img class="app-icon" :src="scope.row.logo" alt="" />
          </template>
        </el-table-column>
        <el-table-column property="name" label=""></el-table-column>
        <el-table-column property="version" label=""></el-table-column>
        <el-table-column property="size" label=""></el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button class="verifone-btn" type="primary" @click="downloadDialogVisible = false">{{ $t('message.ok') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog title="" :visible.sync="appDialogVisible" width="30%" class="quit-dialog">
      <div class="detail-row">
        <h4>{{ $t('message.totalTerminals') }}:&nbsp;&nbsp;</h4>
        <span>{{ appParameterTotal }}</span>
      </div>
      <div class="detail-row">
        <h4>{{ $t('message.downloadTime') }}:&nbsp;&nbsp;</h4>
        <span>{{ appParameterTime }}</span>
      </div>
      <h4>APP</h4>
      <el-table :data="appListParam" width="190" :max-height="518" :show-header="false">
        <el-table-column width="50" property="date" label="日期">
          <template slot-scope="scope">
            <img class="app-icon" :src="scope.row.logo" alt="" />
          </template>
        </el-table-column>
        <el-table-column property="name" label=""></el-table-column>
        <el-table-column property="version" label=""></el-table-column>
        <el-table-column property="size" label=""></el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button class="verifone-btn" type="primary" @click="appDialogVisible = false">{{ $t('message.ok') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog title="" :visible.sync="terminalDialogVisible" width="30%" class="quit-dialog terminalSN-dialog">
      <div class="dialog-body" style="text-align:center">
        <h4 style="text-align:left;">SN:</h4>
        <br />
        <span>{{ terminalSN }}</span>
        <br />
        <br />
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button class="verifone-btn" type="primary" @click="terminalDialogVisible = false">{{ $t('message.ok') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="cancelDialogVisible" width="30%" class="quit-dialog warn-dialog">
      <div class="warn-container flex-row">
        <img class="warn-icon" alt="" src="static/img/alertWarn.png" />
        <span>&nbsp;&nbsp;{{ $t('message.warn') }}</span>
      </div>

      <div class="dialog-body">
        <span>{{ $t('message.downloadCancel') }}</span>
        <span>{{ cancelName }}</span>
        <span>"?</span>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button class="verifone-btn" type="primary" plain @click="cancelDialogVisible = false">{{ $t('message.no') }}</el-button>
        <el-button class="verifone-btn" type="primary" @click="callStopTask(cancelId)">{{ $t('message.yes') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cancelDialogVisible: false,
      downloadDialogVisible: false,
      appDialogVisible: false,
      terminalDialogVisible: false,
      currentType: null,
      releaseRange: '',
      terminalSN: '',
      appParameterTotal: '',
      appParameterTime: '',
      downloadTotal: '',
      downloadType: '1',
      downloadDate: '',
      downloadTime: '',
      installType: '',
      remindType: 0,
      cancelId: '',
      cancelName: '',
      pageNum :1,
      pageCount:1,
      totalPage: 1,
      tableData: [],
      multipleSelection: [],
      appListParam: [],
      appListDownload: [],
      cancelSuccess: this.$t('message.cancelSuccess'),
      queryFlag: false,
      accountInfo:'',
      searchHistory: '',
      queryType:0,//0查询，1搜索
      paramType:0,//类型
      downloadsearch:'',
      queryOptions: [ {
        value: 0,
        label: this.$t('message.downloadTask')
      },{
        value: 1,
        label: this.$t('message.sn')
      }],
    };
  },
  mounted() {
    this.queryTaskList();
    this.setQuery();
  },
  methods: {
    getDivision(){
      this.downloadsearch='';
    },
    setQuery() {
      let roleArr = sessionStorage
        .getItem('verifoneRoleList')
        .split(',')
        .map(str => parseInt(str));
      this.queryFlag = !roleArr.includes(51);
    },
    handleClick(row) {
      console.log(row);
    },
    handleDetail(row) {
      let id = row.taskId;

      //this.currentType = row.taskType;

      /*if(row.taskType == 0 || row.taskType == 1 || row.taskType == 3 || row.taskType == 4) {
          this.$router.replace('/downloadDetail/' + id + '/' + row.taskType);
        }else if(row.taskType == 2) {
          this.queryTaskDetail(2, id);
        }*/
      this.$router.replace('/downloadDetail/' + id + '/' + row.taskType);
    },
    handleStopTask(row) {
      this.cancelId = row.taskId;
      this.cancelName = row.taskName;
      this.cancelDialogVisible = true;
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return 'word-break: keep-all; word-wrap:break-word;';
      }
    },
    changePage(page) {
       this.pageNum = page;
        if(this.queryType == 0) {
          this.queryTaskList();
        }else if(this.queryType == 1) {
          this.searchAccount();
        }
      },
    queryTaskList() {
      let that = this,
        obj = {
          pageNum: this.pageNum
        };

      this.$axios({
        method: 'post',
        url: '/marketplace/task/page',
        headers: { 'Accept-Language': sessionStorage.getItem('acceptLanguage') },
        data: obj
      })
        .then(response => {
          if (response.data.resultCode != 0) {
            this.$message({
              type: 'error',
              message: response.data.desc,
              duration: '3000'
            });
            return;
          } else {
            that.queryType = 0;
            that.tableData = response.data.taskList;
            that.pageCount = response.data.totalPage;

          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    searchAccount(){

    let that = this,
        obj = {
          queryInfo :this.downloadsearch,
          pageNum:this.pageNum,
          queryType:this.paramType
        };
       console.log("11111")
      if(this.downloadsearch ==''){
        console.log("22222222");
        that.pageNum =1;
        this.searchHistory = '';
        this.queryTaskList();
        return ;
      }
      if(this.downloadsearch != this.searchHistory){
        console.log("3333333333333")
        this.pageNum = 1
      } else{
        obj.pageNum = this.pageNum
      }
    this.$axios({
      method: 'post',
      url: '/marketplace/task/queryTaskList',
      headers: { 'Accept-Language': sessionStorage.getItem('acceptLanguage') },
      data: obj
    })
      .then(response => {
        if (response.data.resultCode != 0) {
          this.$message({
            type: 'error',
            message: response.data.desc,
            duration: '3000'
          });
          return;
        }
        else {
          that.queryType = 1;
          that.tableData = response.data.taskList;
          that.pageCount = response.data.totalPage;
          that.searchHistory = that.downloadsearch;
        }
      })
      .catch(err => {
        console.log(err);
      });

    },
    queryTaskDetail(type, id) {
      let that = this,
        obj = {
          id: id,
          taskType: type
        };

      this.$axios({
        method: 'post',
        url: '/marketplace/task/detail',
        headers: { 'Accept-Language': sessionStorage.getItem('acceptLanguage') },
        data: obj
      })
        .then(response => {
          if (response.data.resultCode != 0) {
            this.$message({
              type: 'error',
              message: response.data.desc,
              duration: '3000'
            });
            return;
          } else {
            if (type == 0) {
              that.appListDownload = response.data.appList;
              that.downloadTotal = response.data.terminalNum;
              that.remindType = response.data.remindType;
              that.downloadType = response.data.downloadType;
              that.installType = response.data.installType;
              that.releaseRange = response.data.releaseRange;

              if (that.downloadType == 1) {
                that.downloadDate = response.data.downloadDate;
                that.downloadTime = response.data.downloadTime;
              }

              if (that.installType == 1) {
                that.installDate = response.data.installDate;
                that.installTime = response.data.installTime;
              }

              that.downloadDialogVisible = true;
            } else if (type == 1) {
              that.appListParam = response.data.appList;
              that.appParameterTotal = response.data.terminalNum;
              that.appDialogVisible = true;
            } else if (type == 2) {
              that.terminalSN = response.data.sn;
              that.terminalDialogVisible = true;
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    callStopTask(id) {
      let that = this,
        obj = {
          taskId: id
        };

      this.$axios({
        method: 'post',
        url: '/marketplace/task/stop',
        headers: { 'Accept-Language': sessionStorage.getItem('acceptLanguage') },
        data: obj
      })
        .then(response => {
          if (response.data.resultCode != 0) {
            that.$message({
              type: 'error',
              message: response.data.desc,
              duration: '3000'
            });
            return;
          } else {
            that.$message({
              type: 'success',
              message: this.cancelSuccess,
              duration: '3000'
            });
            that.cancelDialogVisible = false;
            that.queryTaskList(that.currentPage);
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style lang="css" scoped="scoped">
  .select-input-container{
    border: #8c939d;
  }
  .reachInput {
     position: relative;
    /* border-right:none!important;*/
     left: 40px;
   }
  .has-gutter {
    border-bottom: 1px solid #00a0e8;
  }
  .table-container {
    background-color: #fff;
    position: relative;
  }
  .table-main {
    padding: 20px;
  }
  .pagination-main {
    padding: 10px 0;
  }
  .createBtn-main {
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    position: absolute;
    right: 0;
    bottom: 10px;
    align-items: center;
    padding-right: 10px;
  }
  .load-selector {
    background-color: #53bfb7!important;
    color: #fff!important;
    padding: 10px 15px;
    margin: 0 3px 0 20px;
  }
  .arrows-right {
    width: 25px;
    height: 25px;
    transform: rotate(180deg);
    position: relative;
    bottom: -7px;
  }
  .num-container {
    font-size: 15px;
    color: #666;
  }
  .taskName {
    color: #00A0E8;
    cursor: pointer;
  }
  /* .end-btn {
      color: #fff;
      background-color: #E51C23;
      padding: 8px 12px;
  } */
  .app-icon {
    width: 30px;
    height: 30px;
  }
  .detail-row {
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    padding: 0 0 12px 0;
  }
  .downloadDate {
    display: inline-block;
    width: 180px;
  }
  .title-container {
    padding-left: 20px;
  }
  .el-table th, .el-table tr {
    height: 51px!important;
  }
  .terminalSN-dialog .dialog-body {
    text-align: center;
    padding: 0;
  }
  .terminalSN-dialog .dialog-body h4 {
    text-align: left;
    padding-left: 20%;
  }
  .verifone-panel {
    /* margin-top: 62px; */
    margin-top: 12px;
  }
  .invisible-btn {
    visibility: hidden;
  }
  .appManagement-search .el-input__inner {
    border-radius: 20px;
}
.appManagement-search {
    width: 400px;
    border-radius: 20px;
    margin-right: 20px;
}
.search-btn {
    margin-right: 30px;
  }
.rearchSelect {
    width: 150px;
  }

</style>



// WEBPACK FOOTER //
// src/components/page/DownloadList.vue